// @ts-nocheck
import React from 'react'

import { Button } from 'components/shared/Button/Button'
import { Icon, ArrowLeftIcon, InfoIcon } from 'components/shared/Icon/Icon'
import { Subtitle } from './common/Subtitle/Subtitle'
import { Text } from './common/Text/Text'

import styles from './DetailsCard.module.scss'

export const DetailsCard = ({
  children,
  icon = InfoIcon,
  title,
  onBackClick,
  hasDefaultState,
}) => (
  <section className={styles.card}>
    <div className={styles.container}>
      <header className={styles.header}>
        {hasDefaultState ? (
          <Icon className={styles.icon} size={16} {...{ icon }} />
        ) : (
          <Button
            className={styles.button}
            icon={ArrowLeftIcon}
            size="medium"
            variant="text"
            onClick={onBackClick}
          />
        )}
        <h3 className={styles.title}>{title}</h3>
      </header>
      {children}
    </div>
  </section>
)

DetailsCard.Subtitle = Subtitle
DetailsCard.Text = Text
